// extracted by mini-css-extract-plugin
export default {"root":"loading_root__x7sEt","icon":"loading_icon__Z+Rp5","placeHolderShimmer":"loading_placeHolderShimmer__G-5zR"};